var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('page-template',{attrs:{"tableOptions":_vm.tableOptions,"searchOptions":_vm.searchOptions,"toolConfig":_vm.toolConfig,"addColumns":_vm.addColumns,"editColumns":_vm.addColumns}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8b2fc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/member/Query.vue
// module id = null
// module chunks = 